import React from "react";
import "./About.css";
// import ME from "../../assets/me-about.jpg";
import ME from "../../assets/me-2.png";
import { FaAward, FaUserGraduate } from "react-icons/fa";
import { FiUsers } from "react-icons/fi";
import { VscFolderLibrary } from "react-icons/vsc";

const About = () => {
  return (
    <section id="about">
      <h5>Get To Know</h5>
      <h2>About Me</h2>
      <div className="container about_container">
        <div className="about_me">
          <div className="about_me-image">
            <img
              className="my_image w-[700px] h-96 "
              src={ME}
              alt="About_Image"
            />
          </div>
        </div>
        <div className="about_content">
          <p className="text-justify mt-10">
            Passionate and dedicated Web Developer. Always try to grab the new
            features of technology and frameworks. Staying updated with the
            features of technology and frameworks. Staying updated with the
            features of technology and frameworks. Staying updated with the
            latest web development trends and latest web development trends and
            best latest latest web development trends and best practices is
            essential for their professional growth. I am passionate about
            providing care to my work, which keeps me motivated and excited
            about doing my best work.
            {/* <div className='flex p-2 mt-5'>
                    <img className='w-[30px] h-[30px]' src="https://i.ibb.co/X8NkhDT/icon.png" alt="" />
                    <h2 className='text-3xl font-semibold'>Education</h2>
                </div> */}
               
                <div className='flex items-center gap-5 mt-3'>
                     <FaUserGraduate className='w-[40px] h-[40px]'></FaUserGraduate>
                    <div>
                        <h3 className='text-lg font-semibold'> I am a MA in English Literature from Chattogram College.</h3>
                        
                    </div>
                </div>
    
         
          </p>
          <a href="#contact" className="btn btn-primary">
            Lets Talk
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
